import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: "", email: "", password: "", member_code: params.get("code") || "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password || !form.member_code) { toast.error("Email, password and member code are required"); return; }
    setLoading(true);
    try {
      const user = await register(form);
      toast.success(`Welcome to the family, ${user.nickname}!`);
      navigate("/dashboard");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-12">
      <form onSubmit={submit} className="w-full max-w-md card-warm rounded-3xl p-8" data-testid="register-form">
        <div className="text-center mb-6">
          <Logo className="h-20 mx-auto mb-3" />
          <h1 className="headline text-3xl text-[#f7f3ec]">Create Your Account</h1>
          <p className="text-[#a9a196] text-sm">Use the member code from your approval</p>
        </div>
        <input value={form.member_code} onChange={set("member_code")} placeholder="Member Code (e.g. RYD-ABC123)" className="w-full bg-[#1a1816] border border-[#d4af37]/40 rounded-xl px-4 py-3 mb-3 text-[#f3c649] font-mono placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="register-code" />
        <input value={form.name} onChange={set("name")} placeholder="Rider name / nickname" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-3 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="register-name" />
        <input value={form.email} onChange={set("email")} type="email" placeholder="Email" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-3 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="register-email" />
        <input value={form.password} onChange={set("password")} type="password" placeholder="Password" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-5 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="register-password" />
        <button disabled={loading} className="w-full btn-ember rounded-full py-3.5 font-display uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60" data-testid="register-submit">
          {loading ? <Loader2 className="animate-spin" size={18} /> : null} Join The Ryders
        </button>
        <p className="text-center text-sm text-[#a9a196] mt-5">Already have an account? <Link to="/login" className="text-[#f3c649]">Log in</Link></p>
      </form>
    </div>
  );
}
